<button
  [routerLink]="myAccountRoute"
  [ffdPushTagOnClick]="{ event: TagEvent.FfdNotesAccountOpened }"
  class="flex items-center gap-3"
>
  <span class="typo-h5-semibold text-text-primary">{{ user().firstName }}</span>
  <lib-avatars [size]="44" [persons]="[user()]"></lib-avatars>
</button>
